import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNauru = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_981)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0C5.72418 0 0.574591 4.81786 0.0457001 10.9565H23.9543C23.4254 4.81786 18.2758 0 12 0Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.2758 24 23.4254 19.1821 23.9543 13.0435H0.0457001C0.574591 19.1821 5.72418 24 12 24Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.91308 16.1739L8.56842 16.8064L9.28444 18.1087L7.82433 17.8293L7.63931 19.3043L6.62227 18.2195L5.60526 19.3043L5.42025 17.8293L3.96009 18.1086L4.67615 16.8064L3.3315 16.1739L4.6762 15.5414L3.96009 14.2392L5.4202 14.5185L5.60531 13.0435L6.62227 14.1283L7.63936 13.0435L7.82433 14.5185L9.28449 14.2392L8.56847 15.5415L9.91308 16.1739Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_981",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgNauru;
